import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaChartPie,
  FaListAlt,
  FaBox,
  FaCheckCircle,
  FaClipboardList,
  FaPlus,
  FaChevronLeft,
  FaChevronRight,
  FaHistory
} from "react-icons/fa";
import '../styles/Sidebar.css';

const AssetUserSidebar = ({ user, activeTab, onTabChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleNavClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
    if (tab === 'asset-request') {
      navigate('/asset-request');
    }
  };

  return (
    <div className={`asset-user-sidebar ${isCollapsed ? 'collapsed' : ''}`}>

      {/* Toggle Collapse Button */}
      <button
        className="sidebar-toggle-btn"
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>


      {/* Navigation */}
      <nav className="sidebar-nav">
        <button 
          className={`nav-btn ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => handleNavClick('overview')}
          title="Overview"
        >
          <FaChartPie className="nav-icon" />
          <span>Overview</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'all-assets' ? 'active' : ''}`}
          onClick={() => handleNavClick('all-assets')}
          title="All Assets"
        >
          <FaListAlt className="nav-icon" />
          <span>All Assets</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'available' ? 'active' : ''}`}
          onClick={() => handleNavClick('available')}
          title="Available Assets"
        >
          <FaBox className="nav-icon" />
          <span>Available</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'my-assets' ? 'active' : ''}`}
          onClick={() => handleNavClick('my-assets')}
          title="My Assets"
        >
          <FaCheckCircle className="nav-icon" />
          <span>My Assets</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'my-requests' ? 'active' : ''}`}
          onClick={() => handleNavClick('my-requests')}
          title="My Requests"
        >
          <FaClipboardList className="nav-icon" />
          <span>Requests</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'asset-history' ? 'active' : ''}`}
          onClick={() => navigate('/asset-user-history')}
          title="Asset History"
        >
          <FaHistory className="nav-icon" />
          <span>History</span>
        </button>

        <button 
          className={`nav-btn ${activeTab === 'asset-request' ? 'active' : ''}`}
          onClick={() => handleNavClick('asset-request')}
          title="Request Asset"
        >
          <FaPlus className="nav-icon" />
          <span>Request</span>
        </button>
      </nav>
    </div>
  );
};

export default AssetUserSidebar;